import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'

class NewsGridSection extends Section {
  initState() {
    return {
      loadMoreUrl: null
    }
  }

  init() {
    if (this.refs.loadMore) {
      this.state.loadMoreUrl = this.refs.loadMore.href
      on(this.refs.loadMore, 'click', (e) => this.loadMore(e))
    }
  }

  loadMore(e) {
    e.preventDefault()
    if (!this.state.loadMoreUrl) {
      return
    }
    fetch(this.state.loadMoreUrl)
      .then(res => res.text())
      .then(data => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(data, 'text/html')
        const els = doc.querySelectorAll('.post-card')
        Array.from(els).forEach(el => {
          if (this.refs.loadMoreWrapper) {
            this.el.insertBefore(el, this.refs.loadMoreWrapper)
          }
          else {
            this.el.appendChild(el)
          }
        })
        // test new pagination
        const loadMoreEl = doc.querySelector('.newsgrid-loadmore > a')
        if (loadMoreEl) {
          this.state.loadMoreUrl = loadMoreEl.href
        }
        else {
          this.refs.loadMoreWrapper.remove()
        }
      })
  }
}

register('newsgrid', NewsGridSection)
